
/* This file contains all the actions that are used by multiple connectors
or which are too complex to reasonably keep in one connector (i.e. those making Axios network REST calls) */
import CAC from './Constants';
import CFG from './Configconstants'
import axios from 'axios';

/* A call intended to do a general refresh -- may not do that yet. 
Eventually can help with things like timers. */
export const tickleCendInfo = () =>({
    type: CAC.CENDINFO,
});


/* Hardcoded to make the call from v3 because that is the minimum version supporting this call and will return later versions. */
export function pwGetServerVersion() {    
    const request = axios({
        method: 'get',
        url: `${CFG.BASEURL}3.00/system/version.json`,
        headers: [],
        responseType: 'json'
      });
    return{
        type: CAC.VERSIONGET,
        payload: request
    }
}

/* Promise return for pwGetServerVersion */
export const pwGetServerVersionSuccess = (data) => ({
    type: `${CAC.VERSIONGET}_SUCCESS`,
    payload: data
});

/* Promise return for pwGetServerVersion */
export const pwGetServerVersionFailure = (error) => ({
    type: `${CAC.VERSIONGET}_FAILURE`,
    payload: error
});


/* Get a list of every user on the Planworld engine.
This is a system call because we do not expect that every engine codebase will support it. */
export function pwGetUserlist() { 
    var currentUrl = `${CFG.BASEURL}3.00/system/userslocal.json` + "?token=" + sessionStorage.getItem("token");
    const request = axios({
        method: 'get',
        url: currentUrl,
        headers: [],
        responseType: 'json'
      });
    return{
        type: CAC.USERLOCALGET,
        payload: request
    }
}

/* Promise return for pwGetUserlist */
export const pwGetUserlistSuccess = (data) => ({
    type: `${CAC.USERLOCALGET}_SUCCESS`,
    payload: data
});

/* Promise return for pwGetUserlist */
export const pwGetUserlistFailure = (error) => ({
    type: `${CAC.USERLOCALGET}_FAILURE`,
    payload: error
});


/* Get a list of every user that has a send conversation with your user 
and the times when both sides of the coversation were received and seen (so four times) */
export function pwGetSendlist() { 
    var currentUrl = `${CFG.BASEURL}3.00/send/sendlist.json` + "?token=" + sessionStorage.getItem("token");
    const request = axios({
        method: 'get',
        url: currentUrl,
        headers: [],
        responseType: 'json'
      });
    return{
        type: CAC.SENDLISTGET,
        payload: request
    }
}

/* Promise return for pwGetSendlist */
export const pwGetSendlistSuccess = (data) => ({
    type: `${CAC.SENDLISTGET}_SUCCESS`,
    payload: data
});

/* Promise return for pwGetSendlist */
export const pwGetSendlistFailure = (error) => ({
    type: `${CAC.SENDLISTGET}_FAILURE`,
    payload: error
});

/* Get all send messages between your user and another user. */
export function pwGetSends(senduser) { 
    var currentUrl = `${CFG.BASEURL}3.00/send/send/${senduser}.json` + "?token=" + sessionStorage.getItem("token");
    const request = axios({
        method: 'get',
        url: currentUrl,
        headers: [],
        responseType: 'json'
      });
    return{
        type: CAC.SENDGET,
        payload: request
    }
}


/* Promise return for pwGetSends */
export const pwGetSendsSuccess = (data) => ({
    type: `${CAC.SENDGET}_SUCCESS`,
    payload: data
});

/* Promise return for pwGetSends */
export const pwGetSendsFailure = (error) => ({
    type: `${CAC.SENDGET}_FAILURE`,
    payload: error
});


/* Send a send message via REST post. Note that the post has to have the variable name planworld_post */
export function pwPostSend (senduser, post){
    var qs = require('qs');
    var currentUrl = `${CFG.BASEURL}3.00/send/send/${senduser}.json` + "?token=" + sessionStorage.getItem("token");
    const postrequest = axios.post(currentUrl, qs.stringify({'planworld_post': post}), {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        }
    });
      return{
        type: CAC.SENDPOST,
        payload: postrequest,
    }
}

/* Promise return for pwPostSend */
export const pwPostSendSuccess = (data) => ({
    type: `${CAC.SENDPOST}_SUCCESS`,
    payload: data
});

/* Promise return for pwPostSend */
export const pwPostSendFailure = (error) => ({
    type: `${CAC.SENDPOST}_FAILURE`,
    payload: error
});

/* Update the status message of the Cend client. 
Not a network call, just changing a string that gets displayed in the interface. */
export const pwUpdateMessageStatus = (stringMessageStatus) => ({
    type: `${CAC.MESSAGESTATUS}`,
    payload: stringMessageStatus
});




// WEBPACK FOOTER //
// ./src/Actions.js